var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  服装品牌\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }